(() => {
  if (window.MybeSupportReady) return;
  window.MybeSupportReady = true;
  let opened = false;
  function load() {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = window.CRISP_WEBSITE_ID || '12069f4d-aa94-4993-839d-cf8199051097';
    if (document.querySelector('script[src*="client.crisp.chat/l.js"], .crisp-client, #crisp-chatbox')) return;
    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    script.addEventListener('error', () => script.remove(), {once:true});
    document.head.appendChild(script);
  }
  function open() {
    opened = true;
    load();
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  }
  window.loadCrispWidget = load;
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (link.textContent.trim().toLowerCase() !== 'live chat') return;
    event.preventDefault();
    open();
  });
  const init = () => {
    if (opened) return;
    load();
    window.$crisp.push(['do', window.innerWidth > 1023 ? 'chat:show' : 'chat:hide']);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
